export default __webpack_public_path__ + "static/media/shadow.9c2520a3.png";